import { z } from 'zod'
import { FormConfigLoader } from '@/lib/formConfigLoader'
import formYaml from './form.yml?raw'

const formConfig = FormConfigLoader.loadFormConfig(formYaml)
export const FORM_CONFIG = formConfig

export const TestFailDeviceFormSchema = z.object({
  deviceTestCompletionDate: z.string({
    message: 'Test Completion Date is required',
  }),
  testFailureReason: z
    .string()
    .min(1, 'A failure reason is required')
    .max(500, 'Reason cannot exceed 500 characters'),
})

export type TestFailDeviceFormData = z.infer<typeof TestFailDeviceFormSchema>
